<template>
  <MainLayout page-name="fees-for-stop-master">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="preparation" @click="clickPreparation">料金マスタ準備</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
        @clear="clickClear"
        category="master"
      >
        <ChargeYear v-model="simpleSearchFormModel.charge_year" ref="childChargeYear" label="料金年度" prop="charge_year" :searchCond="true" :initialize="true" :required="true" tableType="STOP" yearType = "reference" mode = "this" selectedIndex="0"/>
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :default-sort="{ prop: 'route_code', order: 'descending' }"
      :selectable="deletable"
      :multiSelect="false"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <RouteCodeColumn />
        <FeeColumn label="適用最小重量" prop="min_weight" :formatter="formatterMin" />
        <FeeColumn label="適用最大重量" prop="max_weight" :formatter="formatterMax" />
        <DateTimeColumn label="更新日時" prop="updated_on" />
        <BlankColumn />
        <!-- <MenuColumn @copy="copyRow" :cbdelete="deleteRow" :deletable="deletable" /> -->
      </template>
    </Table>
    <FeesForStopMasterPreparationDialog
      :visible.sync="preparationDialogVisible"
      @refresh="refreshSearch"
    />
    <FeesForStopMasterEditDialog
      :visible.sync="editDialogVisible"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import ChargeYear from '@/components/molecules/form/select/ChargeYear.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import RouteCodeColumn from '@/components/molecules/table/RouteCodeColumn.vue'
import FeeColumn from '@/components/molecules/table/FeeColumn.vue'
import DateTimeColumn from '@/components/molecules/table/DateTimeColumn.vue'
import BlankColumn from '@/components/molecules/table/BlankColumn.vue'
// import MenuColumn from '@/components/molecules/table/MenuColumn.vue'
import FeesForStopMasterPreparationDialog from '@/components/pages/feeMaster/feesForStopMaster/FeesForStopMasterPreparationDialog.vue'
import FeesForStopMasterEditDialog from '@/components/pages/feeMaster/feesForStopMaster/FeesForStopMasterEditDialog.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    ChargeYear,
    SimpleSearch,
    Table,
    RouteCodeColumn,
    FeeColumn,
    DateTimeColumn,
    BlankColumn,
    // MenuColumn,
    FeesForStopMasterPreparationDialog,
    FeesForStopMasterEditDialog
  },
  mixins: [
  ],
  data () {
    return {
      title: '停留料金マスタ',
      tableData: [],
      simpleSearchFormModel: {
        charge_year: ''
      },
      currentRow: {},
      preparationDialogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('feesForStopMasterSearchCond')
  },
  methods: {
    clickPreparation () {
      this.preparationDialogVisible = true
    },
    // clickRegister () {
    //   this.currentRow = {}
    //   this.registerDialogVisible = true
    // },
    // clickDetailSearch () {
    //   this.detailDalogVisible = true
    // },
    clickSearch () {
      sessionStorage.setItem('feesForStopMasterSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    clickClear () {
      this.$set(this.simpleSearchFormModel, 'charge_year', this.$refs.childChargeYear.options[0].value)
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('feesForStopMasterSearchCond'))
      this.$axios
        .get('/search-fees-for-stop-master', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch (chargeYear) {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForStopMasterSearchCond'))
      if (!searchCond) {
        this.$set(this.simpleSearchFormModel, 'charge_year', chargeYear)
        sessionStorage.setItem('feesForStopMasterSearchCond', JSON.stringify(this.simpleSearchFormModel))
      } else {
        this.$set(this.simpleSearchFormModel, 'charge_year', searchCond.charge_year)
      }

      this.search()
    },
    // clickRow (row, column, event) {
    //   this.currentRow = row
    //   this.editDialogVisible = true
    // },
    async clickRow (row, table) {
      this.$loadingMask.on()
      this.currentRow = row
      await this.searchDetailTable(this.currentRow)
      this.editDialogVisible = true
      this.tableData = table
    },
    // 子テーブルのデータを取得するlambdaを呼び出す関数
    async searchDetailTable (currentRow) {
      const searchCond = JSON.parse(JSON.stringify(currentRow))
      await this.$axios
        .get('/search-fees-for-stop-detail-master', { params: searchCond })
        .then((res) => {
          this.currentRow.details = res.data.list.details
          console.log(this.currentRow)
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    // copyRow (row) {
    //   const currentRow = { ...row }
    //   if (parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm())) {
    //     currentRow.billing_ym = ''
    //   }
    //   this.currentRow = currentRow
    //   this.registerDialogVisible = true
    // },
    // deleteRow (row) {
    //   this.deleteRows([row])
    // },
    // async deleteRows (rows) {
    //   if (!(await this.$fcMessage.messageBox(this.title, 'CMN0003W'))) {
    //     return
    //   }

    //   this.$loadingMask.on()
    //   await this.$axios
    //     .delete('/fees-for-stop', { data: rows })
    //     .then((res) => {
    //       this.$fcMessage.showMessage(res.data.message)
    //       this.search()
    //     })
    //     .catch((e) => {
    //       this.$loadingMask.off()
    //       if (e.response) {
    //         switch (e.response.status) {
    //           case 402:
    //             this.$fcMessage.showMessage(e.response.data.message, true)
    //             break
    //           default:
    //         }
    //       }
    //     })
    // },
    // deletable (row, index) {
    //   // 削除可能条件
    //   return !(parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm()) || row.regist_type === '1')
    // },
    formatterMin (row, column) {
      if (row.min_weight !== null) {
        return String(row.min_weight).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    },
    formatterMax (row, column) {
      if (row.max_weight !== null) {
        return String(row.max_weight).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.dummy {
  display: none;
}
// th.billing-ym{
//   display: none;
// }
// td.billing-ym{
//   display: none;
// }
</style>
